import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { BsChevronRight  } from "react-icons/bs"; // Bootstrap Icons (>)
import {alertActions, authActions} from '../../../store/actions'
import Alert from '../../../module/alert/'

let inputRef;
const LoginPass = props => {
      
    const inputRef = useRef();
    const pinArr = ["", "", "", "", "", ""];
    const [pinNum, setPinNum] = useState("");
    // const [pinNumFocus, setPinNumFocus] = useState(true);
    
    useEffect(() => {
        console.log("props.deviceId = = = " , props.deviceId);
    }, [props.deviceId]);


     useEffect(() => { 
         if (pinNum.length === 6) {
             /**
              *  간편로그인 서버로요청
              */
             props.passLogin(
                 pinNum,
                 props.deviceId
             )
         }
    }, [pinNum])

    useEffect(() => { 
        if(pinNum.length === 6){
            // 로그인 실패시 
            if(props.pinReSet === true ){
                setPinNum("");
                inputRef.current.value="";
            }   
        }
   }, [props.pinReSet, inputRef, pinNum])

    return(
    <React.Fragment>
        <div className="content">
            <div className="inner">

                <div className="login section-loginpass">
                    <div className={"login-wrap"}>

                        <div className="login-title">
                            <h5>간편비밀번호 로그인</h5>
                        </div>

                        <div className="login-body">
                            <div className="login-content">
                                <form name="form">
                                    <fieldset>
                                    <div
                                        style={{ position: 'relative' }}
                                        className="pin-area"
                                        onClick={() => inputRef.current.focus()}
                                    >
                                        <h5 className="pin-area--title">간편비밀번호 6자리를 입력해주세요</h5>
                                        <input
                                            type="number" // 숫자 패드만 나오게
                                            pattern="\d*" // iphone 숫자 패드만 나오게
                                            disabled={pinNum.length === 6}
                                            // android는 width가 1이상이어야 value값이 정상적으로 들어옴
                                            style={{ position: 'absolute', width: 1, opacity: 0 }}
                                            ref={inputRef}
                                            // onFocus={() => setPinNumFocus(true)}
                                            // onBlur={() => setPinNumFocus(false)}
                                            onChange={({ target }) => {
                                                const value = target.value.substr(0, 6);
                                                setPinNum(value);

                                                if (target.value.length > 6) {
                                                    target.value = value;
                                                }
                                            }}
                                            // setPinNum(target.value)
                                        />
                                        {/* width: 1 때문에 안드로이드에서 인풋이 클릭되어 가리는 용도 */}
                                        <div style={{ position: 'absolute',  top: 0, left: 0, right: 0, bottom: 0 }} />
                                        {
                                            pinArr.map((x, idx) => (
                                                <span
                                                    key={idx}
                                                    //className={`word ${pinNum.length >= idx + 1 ? 'active' : ''} ${pinNumFocus && ((pinNum.length + 1) === idx + 1 || (pinNum.length === 0 && idx === 0)) ? 'blink' : ''}`} />
                                                    className={`word${pinNum && pinNum.length >= idx + 1 ? ' active' : ''}`} />
                                                )
                                            )
                                        }
                                    </div>
                                    
                                    </fieldset>                                       
                                </form>                                   

                                <div className="login-location-info text-center">
                                    <a href="/LoginPassReset" className="link-arr">간편비밀번호 재설정 <BsChevronRight /></a>                                        
                                </div>
                                <div className="login-location-info text-center">
                                    <a href="/login" className="link-arr">로그인하기 <BsChevronRight /></a>
                                </div>
                            </div>

                        </div>
                        {/*  login-body */}
                        
                    </div>
                </div>

            </div>
        </div>
        <Alert/>
    </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        auth : state.auth,
        pinReSet : state.auth?.pinReSet,
        deviceId: state.userInfo?.deviceId
    }
}
const actionCreators = {
    passLogin: authActions.passLogin,
    error: alertActions.error
}

export default connect(
    mapStateToProps,
    actionCreators
)(LoginPass)

